import { apiWrapper } from 'api';

// 키 목록 조회
export const getApiKeyList = async () => {
  try {
    const response = await fetch('/api/v1/datainsight/playground/apikey', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 401) {
      return [];
    }

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error('Failed to fetch API keys:', error);
    return [];
  }
};

// 키 생성
export const createApiKey = async () => {
  const res = await apiWrapper('/api/v1/datainsight/playground/genkey', {
    method: 'POST'
  });

  const data = await res.json();
  return data.data;
};

// 키 삭제
export const deleteApiKey = async (
  selectedRow: number | null,
  keyList: { uuid?: string }[] | null
) => {
  if (selectedRow === null) return;
  if (!keyList) return;

  return await apiWrapper('/api/v1/datainsight/playground/delkey', {
    method: 'POST',
    body: JSON.stringify({ uuid: keyList[selectedRow as number].uuid! }),
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

// 키 수정
export const updateApiKey = async (uuid: string, newName: string) => {
  return await apiWrapper('/api/v1/datainsight/playground/updatekey', {
    method: 'POST',
    body: JSON.stringify({
      uuid,
      new_apikey_name: newName
    }),
    headers: {
      'Content-Type': 'application/json'
    }
  });
};
